import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Link, Box } from '@material-ui/core';

import { useStyles } from '../../../hooks';
import styles from './styles';

export const SwissGroupItem = ({
  link,
  logos: { logoGrey, logoColor },
  alt
}) => {
  const classes = useStyles(styles);
  const [src, setSrc] = useState(logoGrey);

  return (
    <Grid item className={classes.root}>
      <Link
        href={link}
        target="_blank"
        underline="none"
      >
        <Box
          component="img"
          src={src} 
          alt={alt} 
          className={classes.logo}
          onMouseEnter={() => setSrc(logoColor)}
          onMouseOut={() => setSrc(logoGrey)}
        />
      </Link> 
    </Grid>
  );
}

SwissGroupItem.propTypes = {
  link: PropTypes.string.isRequired,
  logos: PropTypes.shape({
    logoGrey: PropTypes.string.isRequired,
    logoColor: PropTypes.string.isRequired,
  }).isRequired,
  alt: PropTypes.string.isRequired,
}
